// @styles 
import './styles.scss'

export default function TitleDescription({info}) {
    return (
        <div className='text-ppl'>
            <h3 className='text-ppl__title'>{info && info.label}</h3>
            <p className='text-ppl__description'>{info && info.description} </p>
        </div>
    )
}